import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User, Briefcase, Wallet, Phone, FileText } from "lucide-react";

const SalaryBankDetails = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    organization_uuid: "",
    employee_uuid: "",
    bank_name: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    branch_name: "",
    account_type: "",
    verification_status: "Pending",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleNext = () => {
    console.log("Salary & Bank Data:", formData);

    navigate("/hr/employee/add/emergency");
  };

  const handlePrevious = () => {
    navigate("/hr/employee/add/employment");
  };

  return (

    
    <div className="p-8 bg-slate-50 min-h-screen">

       

    {/* Header */}
    <h1 className="text-5xl font-bold text-slate-900">
      Salary & Bank Details
    </h1>

    <p className="text-slate-500 text-xl mt-2 mb-8">
      Step 3 of Employee Creation
    </p>
      {/* Stepper */}
      <div className="bg-white border rounded-2xl p-6 mb-8">
        <div className="flex items-center justify-between">

          <div className="flex flex-col items-center">
            <User className="text-green-600" />
            <span>Personal</span>
          </div>

          <div className="flex-1 h-1 bg-green-600 mx-4"></div>

          <div className="flex flex-col items-center">
            <Briefcase className="text-green-600" />
            <span>Employment</span>
          </div>

          <div className="flex-1 h-1 bg-green-600 mx-4"></div>

          <div className="flex flex-col items-center">
            <Wallet className="text-blue-600" />
            <span className="font-semibold text-blue-600">
              Salary
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-300 mx-4"></div>

          <div className="flex flex-col items-center">
            <Phone className="text-slate-400" />
            <span>Emergency</span>
          </div>

          <div className="flex-1 h-1 bg-slate-300 mx-4"></div>

          <div className="flex flex-col items-center">
            <FileText className="text-slate-400" />
            <span>Documents</span>
          </div>

        </div>
      </div>

     

      {/* Form */}
      <div className="bg-white border rounded-2xl p-8">

        <div className="grid grid-cols-2 gap-6">

          <input
            type="text"
            name="organization_uuid"
            placeholder="Organization UUID"
            value={formData.organization_uuid}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="employee_uuid"
            placeholder="Employee UUID"
            value={formData.employee_uuid}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="bank_name"
            placeholder="Bank Name"
            value={formData.bank_name}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="account_holder_name"
            placeholder="Account Holder Name"
            value={formData.account_holder_name}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="account_number"
            placeholder="Account Number"
            value={formData.account_number}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="ifsc_code"
            placeholder="IFSC Code"
            value={formData.ifsc_code}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <input
            type="text"
            name="branch_name"
            placeholder="Branch Name"
            value={formData.branch_name}
            onChange={handleChange}
            className="border rounded-xl p-4"
          />

          <select
            name="account_type"
            value={formData.account_type}
            onChange={handleChange}
            className="border rounded-xl p-4"
          >
            <option value="">Select Account Type</option>
            <option value="Savings">Savings</option>
            <option value="Current">Current</option>
          </select>

          <select
            name="verification_status"
            value={formData.verification_status}
            onChange={handleChange}
            className="border rounded-xl p-4"
          >
            <option value="Pending">Pending</option>
            <option value="Verified">Verified</option>
            <option value="Rejected">Rejected</option>
          </select>

        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-10">

          <button
            onClick={handlePrevious}
            className="px-8 py-3 border border-slate-300 rounded-xl hover:bg-slate-100"
          >
            ← Previous
          </button>

          <button
            onClick={handleNext}
            className="px-8 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700"
          >
            Next →
          </button>

        </div>

      </div>
    </div>
  );
};

export default SalaryBankDetails;